// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x9OSI2 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;
}

.UIwswO {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--text-neutral-dark);
  margin: 0;
  padding: 0;
}

.WIfRQB {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--text-neutral-dark);
  margin: 0;
  padding: 0;
}

.FJBHM8 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.AaupVR {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.aoLepZ {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.wMHpFS {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-style: normal;
  font-size: var(--font-size-md, 14px);
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;
  color: var(--text-neutral-dark);
  margin: 0;
  padding: 0;
}

.LDJ4Te {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  width: 12px;
  height: 12px;
  opacity: 1;
}

.LDJ4Te svg {
  width: 12px;
  height: 12px;
}

.CArPeG {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

/* Custom tooltip content styling for line breaks */
[data-testid*='password-creation-tooltip-passwordContent'] > div:first-child,
[data-testid*='password-creation-tooltip-confirm-passwordContent'] > div:first-child {
  white-space: pre-line !important;
  text-align: center !important;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/components/Onboarding/components/PasswordCreation/PasswordCreation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA,mDAAmD;AACnD;;EAEE,gCAAgC;EAChC,6BAA6B;AAC/B","sourcesContent":[".passwordCreationWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.passwordCreationTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  padding: 0;\n}\n\n.passwordCreationSubtitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  padding: 0;\n}\n\n.passwordCreationField {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.passwordCreationInputWrapper {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.passwordCreationLabelContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.passwordCreationLabel {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-style: normal;\n  font-size: var(--font-size-md, 14px);\n  line-height: 100%;\n  letter-spacing: 0px;\n  vertical-align: middle;\n  color: var(--text-neutral-dark);\n  margin: 0;\n  padding: 0;\n}\n\n.passwordCreationInfoIcon {\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  width: 12px;\n  height: 12px;\n  opacity: 1;\n}\n\n.passwordCreationInfoIcon svg {\n  width: 12px;\n  height: 12px;\n}\n\n.passwordCreationActions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n/* Custom tooltip content styling for line breaks */\n:global([data-testid*='password-creation-tooltip-passwordContent'] > div:first-child),\n:global([data-testid*='password-creation-tooltip-confirm-passwordContent'] > div:first-child) {\n  white-space: pre-line !important;\n  text-align: center !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"passwordCreationWrapper": `x9OSI2`,
	"passwordCreationTitle": `UIwswO`,
	"passwordCreationSubtitle": `WIfRQB`,
	"passwordCreationField": `FJBHM8`,
	"passwordCreationInputWrapper": `AaupVR`,
	"passwordCreationLabelContainer": `aoLepZ`,
	"passwordCreationLabel": `wMHpFS`,
	"passwordCreationInfoIcon": `LDJ4Te`,
	"passwordCreationActions": `CArPeG`
};
module.exports = ___CSS_LOADER_EXPORT___;
